import { IOpenDrawer } from 'us.collection.case/reducers/Dashboard/Interfaces'

export const OpenDrawer: IOpenDrawer = {
    title: "",
    visible: false
}